import { Heading2, BodyLarge } from '@casavo/base-ui'
import cn from 'classnames'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'
import React from 'react'

import { Header } from '@/components/Header'
import { linkBuilder } from '@/components/Link/linkBuilder'
import { ButtonLink } from '@/design-lib/components/ButtonLink'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import ListingNotFoundHead from '@/heads/listing-not-found'
import { backgroundColor, marginBottom } from '@/shared-styles/styles.css'
import { defaultCitiesByLocale, localesByCountryName } from '@/utils/locale-variables'
import { getMenuLinks } from '@/utils/locale-variables/menuLinks'

import { imgContainer } from './styles.css'

/** Redirects to the default city of the locale if the user lands on the page of a city that does not
 *  match to the current locale (to prevent nasty error pages) */
export const getDefaultCityOfCurrentLocale = (locale: Locale) => {
  // const countryOfCurentCity = currentCity.country || lang
  const localesOfCurrentCity: Locale[] = localesByCountryName[locale] || []

  if (!localesOfCurrentCity.includes(locale)) {
    return defaultCitiesByLocale[locale]
  }

  // return currentCity.slug
  return locale
}

export const ListingNotFound: React.FC = () => {
  const { lang, t } = useTranslation()
  const headerData = getMenuLinks(lang)

  const {
    publicRuntimeConfig: { imageBasePath, lisaWebsite },
  } = getConfig()

  return (
    <>
      <ListingNotFoundHead />

      {typeof headerData !== 'undefined' && <Header links={headerData} />}

      <div
        className={cn(
          backgroundColor.lightBlue,
          sprinkles({
            textAlign: 'center',
          })
        )}
      >
        <div
          className={cn(
            imgContainer,
            sprinkles({
              margin: 'auto',
              paddingBottom: '5xl',
              paddingTop: { mobile: 'xl' },
              paddingX: 'm',
            })
          )}
        >
          <img
            alt=""
            className={sprinkles({ marginBottom: 'm', marginX: 'auto' })}
            height="300"
            loading="lazy"
            src={`${imageBasePath}/images/concepts/home-chapter-woman.svg`}
            width="300"
          />

          <div className={sprinkles({ textAlign: 'center' })}>
            <Heading2 className={marginBottom['2xl']}>{t('common:listing_not_found_title')}</Heading2>
            <BodyLarge className={sprinkles({ paddingX: { mobile: 'xl' } })}>
              {t('common:listing_not_found_similar_properties_subtitle')}
            </BodyLarge>
          </div>
        </div>
        <div className={sprinkles({ paddingBottom: '4xl', textAlign: 'center' })}>
          <ButtonLink
            isNextLink
            href={lisaWebsite + linkBuilder.housesForSale.url(lang)}
            label={t('common:listing_not_found_cta')}
            styleVariant="secondary"
          />
        </div>
      </div>
    </>
  )
}
